import React, { useEffect, useState } from 'react';
import { useParams,Link ,useNavigate} from 'react-router-dom';
import { getCompanyById ,deleteContactoEmpresa} from '../services/api';
import '../styles/styles.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import {formatRut} from '../utils/rut';
import {confirmar} from './ConfirmModal';
import {toast} from 'react-toastify';

const DetalleEmpresa = () => {
    const { empresaId } = useParams();
    const [empresa, setEmpresa] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchEmpresa = async () => {
            try {
                const { data } = await getCompanyById(empresaId);
                setEmpresa(data);
            } catch (err) {
                console.error('Error al obtener empresa:', err);
                setError('No se pudo cargar la empresa');
            } finally {
                setLoading(false);
            }
        };
        fetchEmpresa();
    }, [empresaId]);


    const handleDeleteContacto = async (empresaId,contactoId) => {
        if (await confirmar (`¿Está seguro que quiere eliminar este contacto?`,{variante:'peligro'})){
            try{
                await deleteContactoEmpresa(empresaId,contactoId);
                toast.success('Contacto eliminado correctamente');
                navigate(`/empresas/${empresaId}`)
            } catch (err) {
                console.error('Error al eliminar contacto:', err);
                toast.error('Error al eliminar contacto');
            }
        }
    } 
    if (loading) return <p>Cargando empresa...</p>;
    if (error) return <p>{error}</p>;
    if (!empresa) return <p>No se encontró la empresa.</p>;

    return (
        <div className="empresa-layout">
            {/* columna izquierda de empresa */}
            <div className="empresa-card">
                <div className="card-header">
                    <h2>{empresa.nombre_legal}</h2>
                </div>
                <div className="card-body">
                    <p><strong>RUT:</strong> {formatRut(empresa.rut)}</p>
                    <p><strong>Email:</strong> {empresa.email}</p>
                    <p><strong>Ciudad:</strong> {empresa.ciudad}</p>
                    <p><strong>Giro:</strong> {empresa.giro}</p>
                    <p><strong>Razón Social:</strong> {empresa.razon_social}</p>
                    <p><strong>Rubro:</strong> {empresa.rubro}</p>
                    <p><strong>Dirección:</strong> {empresa.direccion}</p>
                    <p><strong>Forma de Pago:</strong> {empresa.forma_pago}</p>
                    <p><strong>Días de Pago:</strong> {empresa.dias_pago}</p>
                </div>
                <div className='card-footer'>
                    <Link to={`/empresas/${empresa.id_usuario}/contactos/crear`} className='btn-create' >Añadir Contacto</Link>
                </div>
            </div>

            {/*columna derecha de contactos*/}
            <div className="contactos-column">
                <h3>Contactos</h3>
                {empresa.contactos && empresa.contactos.length > 0 ? (
                    empresa.contactos.map((c) => (
                        <div key={c.id_contacto} className="contact-card">
                            <div className="card-header">
                                <h4>{c.nombre}</h4>
                            </div>
                            <div className="card-body">
                                <p><strong>Email:</strong> {c.email || '—'}</p>
                                <p><strong>Teléfono:</strong> {c.telefono || '—'}</p>
                                <p><strong>Cargo:</strong> {c.cargo || '—'}</p>
                            </div>
                            <div className="card-footer">
                                <div className="btn-group-row">
                                    <Link
                                        to={`/empresas/${empresa.id_usuario}/contactos/editar/${c.id_contacto}`}
                                        className="btn-icon btn-icon-secondary"
                                        title="Editar contacto"
                                    >
                                        <i className="fas fa-pen"></i>
                                    </Link>
                                    <button
                                        className="btn-icon btn-icon-danger"
                                        onClick={() => handleDeleteContacto(empresa.id_usuario, c.id_contacto)}
                                        title="Eliminar contacto"
                                    >
                                        <i className="fas fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No hay contactos registrados.</p>
                )}
            </div>
        </div>
    );

};

export default DetalleEmpresa;